<template>
  <RequestProposalGrid/>
</template>

<script>
import RequestProposalGrid from './RequestProposalGrid'
export default {
  components: {
    RequestProposalGrid
  },
  data () {
    return {

    }
  },
  created () {
    this.$store.commit('updateTitle', 'Turnado Manual')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/TurnadoManual.vue